<template>
    <div id="account_dashboard" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="glAccountHeader">Account Dashboard</span>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form class="form-horizontal basic-form-container metric-form" id="glAccountForm">
                                    <div class="col-md-12">
                                      <div class="row">
                                        <div class="form-group">
                                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <label> Income By Category</label>
                                                <doughnut-chart :chart-data="chartData"></doughnut-chart>
                                            </div>
                                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                                <label> Expenses By Category</label>
                                               <doughnut-chart :chart-data="expchartData"></doughnut-chart>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                </form>
                            </div>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

// import DoughnutChart from '@/components/DoughnutChart'



export default {
  name: "AccountingDashboard",
  metaInfo() {
    return {
        title: "Create Account Setting | " +process.env.COPYRIGHT_NAME
    }
  },
  components: {
        DoughnutChart: () => import('@/components/graph/DougnutChart')
    },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    account_type:"",
    accountTypesArr:[],
    loading:false,
    account_type_error_msg:"",
    tax_account_type:'',
    tax_account_type_error_msg:'',  
    ap_gl_account_id:'',
    ar_gl_account_id:'',
    sales_gl_account_id:'',
    ge_gl_account_id:'',
    accountsArr:[],
    ar_gl_account_error_msg:'',
    ap_gl_account_error_msg:'',
    sales_gl_account_error_msg:'',
    ge_gl_account_error_msg:'',
    chartData: {},
    expchartData:{},
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'default_account_setting') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadAccountDashBoard();
  },
  methods: {

    loadAccountDashBoard() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/income-expense/summary",
            type: "POST",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                
                if (data.status == "success") {
                    console.log(data.content);
                    self.chartData = {
                        labels: data.content.header.income,
                        datasets: [
                            {
                                borderWidth: 1,
                                borderColor:data.content.summary.inccolor,
                                backgroundColor:data.content.summary.inccolor,
                                data:data.content.summary.income
                            }
                        ]
                    };

                    self.expchartData = {
                        labels: data.content.header.exp,
                        datasets: [
                            {
                                borderWidth: 1,
                                borderColor:data.content.summary.color,
                                backgroundColor:data.content.summary.color,
                                data:data.content.summary.exp
                            }
                        ]
                    };
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'glaccount-details');
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/accounting/AccountingDashboard.vue